// extracted by mini-css-extract-plugin
export default {"container":"YgU4Yp"};